<template>
	<div class="container-list">
		<ul class="tab-wrap">
			<li :class="`tab-btn ${nowIndex == index && 'active'}`" @click="changeTab(index)" v-for="(tab, index) in tabList">
				{{ tab.title }}
			</li>
			<li :class="`tab-btn ${nowIndex == tabList.length && 'active'}`" @click="changeTab(tabList.length)" v-if="$route.query.id || c_num">
				隐患信息
			</li>
			<li :class="`tab-btn ${nowIndex == tabList.length + 1 && 'active'}`" @click="changeTab(tabList.length + 1)" v-if="c_num && !$route.query.id">
				设备信息
			</li>
		</ul>

		<!-- 隐患信息 -->
		<div v-show="nowIndex == tabList.length" v-if="$route.query.id || c_num">
			<danger :c_num="$route.query.id || c_num"></danger>
		</div>
		<div v-show="nowIndex == tabList.length + 1" v-if="!$route.query.id && c_num">
			<facilty :c_num="c_num" />
		</div>
		<el-form ref="form" :model="form" label-width="110px" class="mt20 ml20" v-show="nowIndex == 0">
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item label="单位名称:" prop="base.c_name">
						<span :title="form.base.c_name">{{ form.base.c_name }}</span>
					</el-form-item>
				</el-col>
				<!-- <el-col :span="6">
          <el-form-item
            label="单位编号:"
          
            prop="base.c_number"
          >
            <span :title="form.base.c_number">{{form.base.c_number}}</span>
          </el-form-item>
        </el-col> -->

				<el-col :span="6">
					<el-form-item label="用户/服务类型" prop="base.c_port" style="width:100%">
						<!-- <el-input v-model="form.base.c_port"></el-input> -->
						<el-dropdown size="small" class="ml20">
							<span class="cursor">
								请选择服务类型
								<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown" class="tx-center" style="padding:20px">
								<el-checkbox-group style="height:30px" v-model="services" @change="handlechange">
									<el-checkbox label="3" key="监控">监控</el-checkbox>

									<el-checkbox label="1" key="评估">评估 </el-checkbox>
									<el-checkbox label="2" key="维保"> 维保</el-checkbox>
									<el-checkbox label="4" key="电检">电检</el-checkbox>

									<el-checkbox label="5" key="消检">消检</el-checkbox>
									<el-checkbox label="6" key="验收">验收</el-checkbox>
								</el-checkbox-group>
							</el-dropdown-menu>
						</el-dropdown>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="单位类型:" prop="base.c_type">
						<!-- <v-select :value.sync="form.base.c_type" :id="1"></v-select> -->
						<span :title="this.$map.unitType[form.base.c_type]">{{ this.$map.unitType[form.base.c_type] }}</span>
					</el-form-item>
				</el-col>

				<!-- 
         <el-col :span="6">
          <el-form-item label="营业执照号码" prop="base.c_imployee_number ">
            <el-input v-model="form.base.c_imployee_number"></el-input>
          </el-form-item>
        </el-col> -->

				<el-col :span="6">
					<el-form-item label="所属辖区:" prop="base.c_area">
						<el-cascader
							:options="area"
							v-model="areaValue"
							@change="areaChange"
							disabled
							:props="{
								value: 'area_code',
								label: 'area_name',
								children: 'childArea',
							}"
						>
							<template slot-scope="{ node, data }">
								<span>{{ data.area_name }}</span>
							</template>
						</el-cascader>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="详细地址:" prop="base.c_address">
						<!-- <el-input disabled v-model="form.base.c_address"></el-input> -->
						<div class="flow" :title="form.base.c_address">
							{{ form.base.c_address }}
						</div>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="入网日期:" prop="base.c_in_net">
						<el-date-picker disabled type="date" placeholder="选择日期" v-model="form.base.c_in_net" value-format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="安全监管级别:" prop="base.c_safe_level">
						<!-- <v-select :value.sync="form.base.c_safe_level" :id="38"></v-select> -->
						<span :title="this.$map.jgjb[form.base.c_safe_level]">{{ this.$map.jgjb[form.base.c_safe_level] }}</span>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="上级单位:" prop="base.c_superior">
						<el-select disabled v-model="form.base.c_superior">
							<el-option v-for="item in shangjioption" :key="item.value" :label="item.key" :value="item.value"></el-option>
							<!-- <el-option :value="0" label="请选择上级单位"></el-option>
                            <el-option :value="2" label="联网单位"></el-option>
                            <el-option :value="3" label="消防监管单位"></el-option>
                            <el-option :value="4" label="维保单位"></el-option>
                            <el-option :value="5" label="其他"></el-option> -->
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="所属行业:" prop="base.c_belong_profession">
						<v-select :value.sync="form.base.c_belong_profession" :id="66" :disable="true"></v-select>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="联网状态:" prop="base.c_net_status">
						<!-- <el-radio-group disabled v-model="form.base.c_net_status">
              <el-radio :label="1">已联网</el-radio>
              <el-radio :label="0">未联网</el-radio>
            </el-radio-group> -->
						<span>{{ form.base.c_net_status ? "已联网" : "未联网" }}</span>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="BIM:" prop="base.isbim">
						<!-- <el-radio-group v-model="form.base.isbim">
              <el-radio :label="1">有</el-radio>
              <el-radio :label="0">无</el-radio>
              
            </el-radio-group> -->
						<span>{{ form.base.c_net_status ? "有" : "无" }}</span>
					</el-form-item>
				</el-col>
				<!-- <el-col :span="6">
          <el-form-item label="安装信息表" prop="base.c_setup_table">
            <el-radio-group v-model="form.base.c_setup_table">
              <el-radio :label="1">有</el-radio>
              <el-radio :label="0">无</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col> -->
				<!--                <el-col :span="6">-->
				<!--                    <el-form-item label="省" :rules="{message:'请填写/选择',trigger:'change',required:true}" prop="base.c_province">-->
				<!--                        <el-select v-model="form.base.c_province" placeholder="请选择省份" @change="proChanege">-->
				<!--                            <el-option :value="item.area_code+''" :label="item.area_name"-->
				<!--                                       v-for="item in allAreaList"></el-option>-->
				<!--                        </el-select>-->
				<!--                    </el-form-item>-->
				<!--                </el-col>-->
				<!--                <el-col :span="6">-->
				<!--                    <el-form-item label="市" :rules="{message:'请填写/选择',trigger:'change',required:true}" prop="base.c_city">-->
				<!--                        <el-select v-model="form.base.c_city" placeholder="请选择市" @change="cityChanege">-->
				<!--                            <el-option :value="item.area_code+''" :label="item.area_name"-->
				<!--                                       v-for="item in cityList"></el-option>-->
				<!--                        </el-select>-->
				<!--                    </el-form-item>-->
				<!--                </el-col>-->
				<!--                <el-col :span="6">-->
				<!--                    <el-form-item label="区" :rules="{message:'请填写/选择',trigger:'change',required:true}" prop="base.c_area">-->
				<!--                        <el-select v-model="form.base.c_area" placeholder="请选择区">-->
				<!--                            <el-option :value="item.area_code+''" :label="item.area_name"-->
				<!--                                       v-for="item in areaList"></el-option>-->
				<!--                        </el-select>-->
				<!--                    </el-form-item>-->
				<!--                </el-col>-->

				<!-- <el-col :span="6">
          <el-form-item
            label-width="140px"
            label="消防安全重点单位"
            prop="base.c_import_company"
            :rules="{ message: '请填写/选择', trigger: 'blur', required: true }"
          >
            <el-radio-group v-model="form.base.c_import_company">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col> -->

				<el-col :span="6">
					<el-form-item label="责任人:" prop="base.c_responsible">
						<!-- <el-input v-model="form.base.c_responsible"></el-input> -->
						<span :title="form.base.c_responsible">{{ form.base.c_responsible }}</span>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="责任人联系方式:" label-width="115px" prop="base.c_phone">
						<!-- <el-input v-model="form.base.c_phone"></el-input> -->
						<div class="flow" :title="form.base.c_phone">{{ form.base.c_phone }}</div>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="管理人:">
						<!-- <el-input v-model="form.base.c_manager"></el-input> -->
						<span :title="form.base.c_manager">{{ form.base.c_manager }}</span>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="管理人联系方式:" label-width="120px">
						<!-- <el-input v-model="form.base.c_manager_phone"></el-input> -->
						<span :title="form.base.c_manager_phone">{{ form.base.c_manager_phone }}</span>
					</el-form-item>
				</el-col>
				<!-- <el-col :span="6">
          <el-form-item label="部门负责人:" prop="base.c_department_responsible">
            <span :title="form.base.c_department_responsible">{{form.base.c_department_responsible}}</span>
          </el-form-item>
        </el-col> -->
				<!-- <el-col :span="6">
          <el-form-item
            label="部门联系方式:"
            prop="base.c_video_filter"
            label-width="110px"

          >
            <span :title="form.base.c_video_filter">{{form.base.c_video_filter}}</span>
          </el-form-item>
        </el-col> -->
				<el-col :span="6">
					<el-form-item label="点位数量:" prop="base.c_woker">
						<!-- <el-input v-model="form.base.dwnum"></el-input> -->
						<span :title="form.base.dwnum">{{ form.base.dwnum }}</span>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="职工数:" prop="base.c_woker">
						<!-- <el-input v-model="form.base.c_woker"></el-input> -->
						<span :title="form.base.c_woker">{{ form.base.c_woker }}</span>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="占地面积:" prop="base.c_land_area">
						<!-- <el-input v-model="form.base.c_land_area"></el-input> -->
						<span :title="form.base.c_land_area">{{ form.base.c_land_area }}</span>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="总面积:" prop="base.c_total_area">
						<!-- <el-input v-model="form.base.c_total_area"></el-input> -->
						<span :title="form.base.c_total_area">{{ form.base.c_total_area }}</span>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="邮箱:" prop="base.c_orgin_num">
						<!-- <el-input v-model="form.base.c_orgin_num"></el-input> -->
						<span :title="form.base.c_orgin_num">{{ form.base.c_orgin_num }}</span>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="营业执照号码:" prop="base.c_imployee_number ">
						<!-- <el-input v-model="form.base.c_imployee_number"></el-input> -->
						<span :title="form.base.c_woker">{{ form.base.c_imployee_number }}</span>
					</el-form-item>
				</el-col>

				<!-- <el-col :span="6">
          <el-form-item label="级别:" prop="base.c_level">
            <span :title="form.base.c_level">{{form.base.c_level}}</span>

          </el-form-item>
        </el-col> -->

				<!-- <el-col :span="6">
          <el-form-item label="类型:" prop="base.c_profession_type">
            <span :title="form.base.c_profession_type">{{form.base.c_profession_type}}</span>

          </el-form-item>
        </el-col> -->
				<el-col :span="6">
					<el-form-item label="东经:" prop="base.lon" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
						<!-- <el-input v-model="form.base.lon" placeholder="请输入"></el-input> -->
						<span :title="form.base.lon">{{ form.base.lon }}</span>
						<!-- <getLoation @callback="getLoa"></getLoation> -->
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="北纬:" prop="base.lat" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
						<!-- <el-input v-model="form.base.lat" placeholder="请输入"></el-input> -->
						<!-- <getLoation @callback="getLoa"></getLoation> -->
						<span :title="form.base.lat">{{ form.base.lat }}</span>
					</el-form-item>
				</el-col>

				<!-- <el-col :span="24">
          <el-form-item label="消防隐患" prop="base.c_firefighting_messsage">
            <el-input v-model="form.base.c_firefighting_messsage"></el-input>
          </el-form-item>
        </el-col> -->
				<el-col :span="24">
					<!-- <el-col :span="6">
          <el-form-item label="消防管辖:" prop="base.c_video_ip">
            <span :title="form.base.c_video_ip">{{form.base.c_video_ip}}</span>

          </el-form-item>
        </el-col> -->
					<el-col :span="6">
						<el-form-item label="建筑产权单位:" prop="base.c_power_company ">
							<!-- <el-input v-model="form.base.c_power_company"></el-input> -->
							<span :title="form.base.c_power_company">{{ form.base.c_power_company }}</span>
						</el-form-item>
					</el-col>
				</el-col>
				<el-col :span="24">
					<el-form-item label="单位简介:" prop="base.c_bim_href">
						<!-- <el-input
              type="textarea"
              :rows="5"
              v-model="form.base.c_bim_href"
            ></el-input> -->
						<div style="line-height:20px;height:100px;overflow:auto">
							{{ form.base.c_bim_href }}
						</div>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>

		<div v-for="(item, index1) in tabList" v-show="nowIndex == index1" v-if="index1 !== 0">
			<!-- <div class="btn-box">
        <div class="btn ml10" @click="addList(index1)">
          <i class="icon-tr-newly-added"></i>新增
        </div>
      </div> -->

			<table class="common-table mt20">
				<thead>
					<tr>
						<th v-for="data in item.data">
							{{ data.text }}
						</th>
						<th>操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(data, index) in form[tabList[index1].form]">
						<td class="common-add" v-for="(input, key, index2) in tabList[index1].data">
							<el-input placeholder="请输入" v-model="form[tabList[index1].form][index][input.form_name]" v-if="input.type == 'text'" disabled></el-input>
							<div v-if="input.type == 'select'">
								<v-select :value.sync="form[tabList[index1].form][index][input.form_name]" :disable="true" :id="input.op_id || input.option"></v-select>
							</div>
							<el-date-picker
								type="date"
								value-format="yyyy-MM-dd"
								disabled
								placeholder="选择日期"
								v-model="form[tabList[index1].form][index][input.form_name]"
								v-if="input.type == 'date'"
							></el-date-picker>
							<el-time-picker
								type="time"
								disabled
								value-format="HH:mm:ss"
								placeholder="选择时间"
								v-model="form[tabList[index1].form][index][input.form_name]"
								v-if="input.type == 'timmer'"
							></el-time-picker>
						</td>
						<td class="td-btn">
							<a class="clear-data" @click="del(index)">
								<i class="icon-tr-delete"></i>
							</a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import { getArea } from "../../api/common";
	import { sigtype, port } from "../company/options";
	import getLoation from "../company/getLoation";
	// import facility from '@/components/alarm.vue'
	import danger from "../company/danger";
	import facilty from "../facility/facilty";
	export default {
		data() {
			return {
				area: [],
				services: [],
				areaValue: ["370000", "370200", "370202"],
				shangjioption: [],
				form: {
					base: {
						c_number: "",
						c_type: "",
						c_superior: "",
						c_name: "",
						c_phone: "",
						c_manager_phone: "",
						c_power_company: "",
						c_in_net: "",
						c_net_status: "",
						c_province: "370000",
						c_city: "370200",
						c_area: "370202",
						c_address: "",
						c_setup_table: "",
						isbim: "",
						c_safe_level: "",
						c_belong_profession: "",
						c_orgin_num: "",
						c_responsible: "",
						c_manager: "",
						c_imployee_number: "",
						c_woker: "",
						c_land_area: "",
						c_total_area: "",
						c_bim_href: "",
						c_video_filter: "",
						c_port: "",
						c_plugin_type: "",
						lat: "",
						lon: "",
					},
					get_build: [],
					get_control: [],
					get_server: [],
					get_facility: [],
					get_transmission: [],
					get_interface: [],
					get_message: [],
					get_onduty: [],
					get_video: [],
					get_emphasis: [],
				},
				rules: {},
				nowIndex: 0,
				allAreaList: [],
				cityList: [],
				areaList: [],
				tabList: [
					{ title: "基本信息", form: "base" },
					{
						title: "建筑信息",
						form: "get_build",
						data: [
							{ form_name: "cb_use_type", type: "text", text: "建筑使用性质" },
							{ form_name: "cb_height", type: "text", text: "高度" },
							{ form_name: "cb_on", type: "text", text: "地上层数" },
							{ form_name: "cb_under", type: "text", text: "地下层数" },
							{ form_name: "cb_area", type: "text", text: "面积" },
							{ form_name: "cb_name", type: "text", text: "建筑名称" },
							// {form_name: 'cb_yinqing', type: 'text', text: '火灾引擎'},
						],
					},
					{
						title: "消防重点部位",
						form: "get_emphasis",
						data: [
							{ form_name: "zd_name", type: "text", text: "部位名称" },
							{ form_name: "zd_address", type: "text", text: "所在位置" },
							{ form_name: "zd_nature", type: "text", text: "使用性质" },
							{ form_name: "zd_area", type: "text", text: "建筑面积" },

							{ form_name: "zd_level", type: "text", text: "耐火等级" },
							{
								form_name: "zd_facility",
								type: "select",
								text: "有无消防设施",
								option: [
									{ mc_id: 1, mc_name: "有" },
									{ mc_id: 0, mc_name: "无" },
								],
							},

							{ form_name: "zd_duty_name", type: "text", text: "责任人姓名" },

							{ form_name: "zd_duty_card", type: "text", text: "身份证号码" },

							{ form_name: "zd_duty_phone", type: "text", text: "电话" },
						],
					},
					{
						title: "消防设施",
						form: "get_facility",
						data: [
							{ form_name: "cf_name", type: "text", text: "消防设施名称" },
							{ form_name: "cf_brand", type: "text", text: "消防品牌" },
							{ form_name: "cf_norm", type: "text", text: "规格型号" },
							{ form_name: "cf_node", type: "text", text: "节点数" },
							{ form_name: "cf_quantity", type: "text", text: "数量" },
						],
					},

					{
						title: "消防服务",
						form: "get_server",
						data: [
							{ form_name: "cd_unit_name", type: "text", text: "单位名称" },
							{ form_name: "cd_type", type: "select", text: "单位类型", op_id: 1 },
							{ form_name: "cd_user", type: "text", text: "联系人" },
							{ form_name: "cd_phone", type: "text", text: "联系人电话" },
						],
					},
					// {
					//     title: '消控室',
					//     form: 'get_control',
					//     data: [
					//         {form_name: 'cc_num', type: 'text', text: '消控室编号'},
					//         {form_name: 'cc_name', type: 'text', text: '消控室名称'},
					//         {form_name: 'cc_build', type: 'text', text: '所属建筑'},
					//         {form_name: 'cc_address', type: 'text', text: '地址'},
					//         {form_name: 'cc_user', type: 'text', text: '责任人'},
					//         {form_name: 'cc_device', type: 'text', text: '设备'},
					//     ],
					// },
					{
						title: "值班人员",
						form: "get_onduty",
						data: [
							{ form_name: "co_name", type: "text", text: "值班人员" },
							{ form_name: "co_phone", type: "text", text: "值班人电话" },
							{ form_name: "co_duty", type: "text", text: "值班人职务" },
						],
					},
					{
						title: "视频监控",
						form: "get_video",
						data: [
							{ form_name: "v_video_ip", type: "text", text: "视频id" },
							{ form_name: "v_video_address", type: "text", text: "位置信息" },
						],
					},
				],
			};
		},

		watch: {
			c_num: function(val) {
				this.c_company_num = val;
				this.getList(val);
			},

			c_company_num: function(val) {
				this.$emit("c_num", val);
			},
		},
		props: ["c_num"],

		created() {
			this.$get("/trxf/main/sys/area/arealist").then((res) => {
				this.area = res.data;
				this.area.forEach((a) => {
					a.childArea.forEach((b) => {
						//log(b.childArea)
						b.childArea.forEach((c) => {
							if (!c.childArea.length) {
								c.childArea = null;
							}
						});
					});
				});
			});
			this.$post("/trxf/main/xf/danwei/xfdanweixinxi/querybasemap").then((res) => {
				var arr = [];
				res.data.map((item, index) => {
					arr.push({ key: item.c_name, value: item.c_company_num });
				});
				arr.unshift({ key: "无", value: "" });
				this.shangjioption = arr;
			});
			this.getList(this.c_num);
		},

		mounted() {},
		components: {
			getLoation,
			danger,
			facilty,
		},
		methods: {
			async getList(c_num) {
				await this.$get("/trxf/main/xf/danwei/xfdanweixinxi/detailbase/" + c_num).then((res) => {
					var {
						from: { get_build },
						from,
					} = res;
					if (get_build.length) {
						get_build.map((item, index) => {
							item.old_name = item.cb_name;
						});
					}
					this.form = res.from;
					this.$set(this, "areaValue", [res.from.base.c_province, res.from.base.c_city, res.from.base.c_area]);
					//this.areaValue = [res.from.base.c_province,res.from.base.c_city,res.from.base.c_area]
					this.services = this.form.base.c_port.split(",");
				});
				// this.$post('/checklist/seruritytablefindone',{c_company_num:c_num}).then(res=>{
				//     if(res.data.length){
				//         var data = JSON.parse(res.data[0].company_json).base.ww_problem
				//           this.form.base.c_firefighting_messsage = data
				//     }

				// })
			},
			areaChange(val) {
				log(val);
				this.form.base.c_province = val[0];
				this.form.base.c_city = val[1];
				this.form.base.c_area = val[2];
			},
			getLoa(val) {
				this.form.base.lon = String(val[0]);
				this.form.base.lat = String(val[1]);
			},
			proChanege(flag) {
				this.cityList = [];
				this.areaList = [];
				flag !== 1 && (this.form.base.c_city = "");
				flag !== 1 && (this.form.base.c_area = "");
				this.allAreaList.forEach((it) => {
					if (it.area_code == this.form.base.c_province) {
						this.cityList = it.city;
					}
				});
			},
			cityChanege(flag) {
				this.areaList = [];
				!flag && (this.form.base.c_area = "");
				this.cityList.forEach((it) => {
					if (it.area_code == this.form.base.c_city) {
						this.areaList = it.get_area;
					}
				});
			},
			addList(index) {
				let obj = {};
				this.tabList[this.nowIndex].data.forEach((it) => {
					obj[it.form_name] = "";
				});
				this.form[this.tabList[this.nowIndex].form].push(obj);
			},
			del(index) {
				this.form[this.tabList[this.nowIndex].form].splice(index, 1);
			},
			changeTab(index) {
				this.nowIndex = index;
			},
		},
	};
</script>

<style scoped>
	.flow {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}
	::v-deep .is-disabled .el-input__inner {
		border: none;
		background: none !important;
		color: black !important;
		text-align: left;
	}
	::v-deep .el-form-item__label {
		text-align: left;
	}
</style>
